import { call, select, take } from 'redux-saga/effects';
import { getScribeById } from 'JS/sagas/selectors';
import { HIDE_MODAL } from 'JS/actionCreators/uiActions';
import { COUNTRY_UPDATE } from 'JS/actionCreators/locationActions';
import {
  TRACK_UPGRADE_PAY_NOW_CLICK,
  TRACK_PAYMENT_FAILED,
  TRACK_PAYMENT_SUCCESS
} from 'JS/actionCreators/trackingActions';
import {
  UPGRADE_EXISTING_ACCOUNT_REQUESTED,
  UPGRADE_EXISTING_ACCOUNT_FAILURE,
  UPGRADE_EXISTING_ACCOUNT_SUCCESS
} from 'JS/actionCreators/paymentActions';

import { track } from '../mixpanelProvider';

const getPaymentResultFromActionType = type => {
  let result;
  switch (type) {
    case HIDE_MODAL:
      result = 'Aborted';
      break;
    case TRACK_PAYMENT_SUCCESS:
    case UPGRADE_EXISTING_ACCOUNT_SUCCESS:
      result = 'Success';
      break;
    default:
      result = 'Failure';
  }
  return result;
};

export default function* trackUpgradeModalActions(pathname) {
  let scribeProps = {};
  if (pathname.includes('editor')) {
    const scribeId = pathname.match(/\/editor\/(.+)\/upgrade/)[1];
    const scribe = yield select(state => getScribeById(state, scribeId));
    scribeProps['Scribe ID'] = scribeId;
    scribeProps['Scribe Type'] = scribe?.source?.type;
  }

  while (true) {
    const action = yield take([
      HIDE_MODAL,
      COUNTRY_UPDATE,
      TRACK_UPGRADE_PAY_NOW_CLICK,
      UPGRADE_EXISTING_ACCOUNT_REQUESTED
    ]);
    const { isoCode3: country, currency } = yield select(({ location }) => location);
    const locationProps = {
      'Payment Country': country,
      Currency: currency
    };

    switch (true) {
      case action.type === HIDE_MODAL:
        return yield call(track, 'Abort Upgrade', { ...scribeProps, ...locationProps });
      case action.type === COUNTRY_UPDATE:
        const { isoCode3: countryCode, currency: newCurrency } = action;
        yield call(track, 'Select Country', { ...scribeProps, 'Payment Country': countryCode, Currency: newCurrency });
        continue;
      case action.type === TRACK_UPGRADE_PAY_NOW_CLICK:
        const nextAction = yield take([HIDE_MODAL, TRACK_PAYMENT_FAILED, TRACK_PAYMENT_SUCCESS]);
        if (nextAction.type === HIDE_MODAL) {
          return yield call(track, 'Abort Upgrade', { ...scribeProps, ...locationProps });
        }

        let resultProps = {
          Result: getPaymentResultFromActionType(nextAction.type),
          'Existing Payment Details': false
        };
        if (nextAction.type === TRACK_PAYMENT_FAILED) {
          resultProps['Failure Reason'] = nextAction.reason;
        }
        yield call(track, 'Purchase Now', {
          ...scribeProps,
          ...locationProps,
          ...resultProps
        });

        if (nextAction.type === TRACK_PAYMENT_SUCCESS) {
          return;
        }
        continue;
      case action.type === UPGRADE_EXISTING_ACCOUNT_REQUESTED:
        const nextExistingUserAction = yield take([
          HIDE_MODAL,
          UPGRADE_EXISTING_ACCOUNT_FAILURE,
          UPGRADE_EXISTING_ACCOUNT_SUCCESS
        ]);
        if (nextExistingUserAction.type === HIDE_MODAL) {
          return yield call(track, 'Abort Upgrade', { ...scribeProps, ...locationProps });
        }

        let resultExistingUserProps = {
          Result: getPaymentResultFromActionType(nextExistingUserAction.type),
          'Existing Payment Details': true
        };

        if (nextExistingUserAction.type === UPGRADE_EXISTING_ACCOUNT_FAILURE) {
          resultExistingUserProps['Failure Reason'] = nextExistingUserAction.error;
        }
        yield call(track, 'Purchase Now', {
          ...scribeProps,
          ...locationProps,
          ...resultExistingUserProps
        });

        if (nextExistingUserAction.type === UPGRADE_EXISTING_ACCOUNT_SUCCESS) {
          return;
        }
        continue;
      default:
        break;
    }
  }
}
